import { render } from "./HrMenu.vue?vue&type=template&id=ff7b602e&scoped=true"
import script from "./HrMenu.vue?vue&type=script&lang=js"
export * from "./HrMenu.vue?vue&type=script&lang=js"

import "./HrMenu.vue?vue&type=style&index=0&id=ff7b602e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff7b602e"]])

export default __exports__